import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonMarriageNonResidentCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Registrazione Matrimonio Non Residenti',
    path: '/mutazioni/persona/matrimonio/non-residenti',
  },
];

export const RegistrationMarriageNonResidentCrumbs = [
  ...SearchPersonMarriageNonResidentCrumbs,
  {
    name: 'Registrazione Matrimonio Non Residenti',
    path: '/mutazioni/persona/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
  },
];
